module.exports = __webpack_public_path__ + "static/media/h_05.8d74f28f.png";